"use strict";

export default /*@ngInject*/ $anchorScroll => {
  return {
    restrict: "A",
    link: (scope, el) => $anchorScroll.yOffset = el
  };
};
